// @ts-nocheck
/* eslint-disable react/prop-types */
/**
 * SolidEdge — Standard solid edge with optional label.
 *
 * Supports:
 *   data.color       — stroke colour override (theme tokens supported)
 *   data.text        — label text (alternative to the `label` prop)
 *   data.labelColor  — label colour override
 *   label            — label text (standard ReactFlow prop)
 */
import React, { memo } from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from 'reactflow';
import { useTheme } from '@mui/material/styles';
import SolyticsBox from '../../../SolyticsBox';
import SolyticsTypography from '../../../SolyticsTypography';
import NodeTooltip from '../shared/NodeTooltip';
import { resolveThemeColor } from '../shared/themeColorUtils';

const SolidEdge = memo(
  ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    markerEnd,
    markerStart,
    label,
    data,
  }) => {
    const theme = useTheme();
    const [edgePath, labelX, labelY] = getSmoothStepPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
    });

    const displayLabel = label || data?.text;
    const strokeColor = resolveThemeColor(
      theme,
      data?.color,
      'solyticsFlow.edge.defaultStroke'
    );
    const labelColor = resolveThemeColor(
      theme,
      data?.labelColor,
      'solyticsFlow.edge.labelColor'
    );

    return (
      <>
        <BaseEdge
          id={id}
          path={edgePath}
          markerEnd={markerEnd}
          markerStart={markerStart}
          style={{
            stroke: strokeColor || theme.palette.text.primary,
            strokeWidth: 1.5,
          }}
        />
        {displayLabel && (
          <EdgeLabelRenderer>
            <NodeTooltip tooltip={data?.labelTooltip}>
              <SolyticsBox
                className="nodrag nopan"
                position="absolute"
                bgcolor={theme.palette.background.paper}
                px={1}
                py={0.5}
                borderRadius={1}
                maxWidth={120}
                overflow="hidden"
                sx={{
                  transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                  pointerEvents: 'all',
                }}
              >
                <SolyticsTypography
                  variant="caption"
                  color={labelColor || theme.palette.text.secondary}
                  noWrap
                >
                  {displayLabel}
                </SolyticsTypography>
              </SolyticsBox>
            </NodeTooltip>
          </EdgeLabelRenderer>
        )}
      </>
    );
  }
);
SolidEdge.displayName = 'SolidEdge';

export default SolidEdge;
